import {
  injectable,
  IModuleLifecycleContribution,
  inject,
  IAbilitiesService,
} from '@meego-remote/core/app/contract';
import { ABILITIES } from '@meego-remote/main/platform/private/secondNavCollaboration';
import { BasicAbilities } from '@meego-remote/platform/basic/contract';
import { isTrialDemoEnvironment, TRIAL_DEMO_ABILITIES } from './utils';

@injectable({ implements: [IModuleLifecycleContribution] })
export class TrialDemoModuleLifecycleContribution extends IModuleLifecycleContribution {
  @inject(IAbilitiesService)
  protected readonly abilitiesService!: IAbilitiesService;

  override onInit() {
    // Check if in trial demo environment
    if (!isTrialDemoEnvironment()) {
      return;
    }
    this.setupAbilities();
  }

  private setupAbilities(): void {
    this.abilitiesService.set(BasicAbilities, TRIAL_DEMO_ABILITIES as InstanceType<typeof BasicAbilities>, {
      merge: true,
    });
    const updatedBasicAbilities = this.abilitiesService.getOrCreate(BasicAbilities);
    Object.assign(ABILITIES, updatedBasicAbilities);
  }
}
